
import { Col, Row } from 'react-bootstrap';
import InboxToolbar from 'components/modules/email/InboxToolbar';
import { emails } from 'data/email';
import EmailRow from 'components/modules/email/EmailRow';
import BulkSelectProvider from 'pages/template/providers/BulkSelectProvider';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import SearchBox from 'components/common/SearchBox';
import { ChangeEvent, useState } from 'react';

import PhoenixOffcanvas from 'components/base/PhoenixOffcanvas';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import { useMainLayoutContext } from 'providers/MainLayoutProvider';
import React, { PropsWithChildren, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageBreadcrumb, { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import ResourcesSidebar from './components/ResourcesSidebar';
import EmailSidebar from 'components/modules/email/EmailSidebar';
import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import useAdvanceTable from 'hooks/useAdvanceTable';
import apiClient from 'helpers/apiService';
import { MyResource } from './components/DataDefinitions';
import MyResourceRow from './components/MyResourceRow';



const MyResourcesTable = () => {
  return (
    <div className="border-top">
      <AdvanceTable
        tableProps={{ className: 'phoenix-table fs-9' }}
        rowClassName="hover-actions-trigger btn-reveal-trigger"
      />
      <AdvanceTableFooter pagination className="py-4" />
    </div>
  );
};

const MyResources = () => {

  const page: string = 'inbox'; //'inbox' | 'detail' | 'compose';
  const [openSidebar, setOpenSidebar] = useState(false);
  const { breakpoints } = useBreakpoints();

  const [showResource, setShowResource] = useState(false);
  const handleClose = () => setShowResource(false);


  const [loading, setLoading] = useState(true);

  const [openFilterModal, setOpenFilterModal] = useState(false);
  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    table.setGlobalFilter(e.target.value || undefined);
  };

  const [resources, setResources] = useState<MyResource[]>([]);
  const [resource, setResource] = useState<MyResource>();

  // State to control Toast messages
  const [show, setShow] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const { t } = useTranslation();

  const resourcesListTableColumns: ColumnDef<MyResource>[] = [
    {
      header: t('Resource.table.title'),
      accessorKey: 'resource_name',
      cell: ({ row: { original } }) => {
        const { resource_id, resource_name } = original;

        // Example method to handle the click event
        const handleClick = () => {
          setResource(original);
          setShowResource(true);
          // Call your desired method here
        };

        return (
          <span
            onClick={handleClick}
            className="fw-semi-bold text-primary cursor-pointer"
            style={{ textDecoration: 'underline' }} // Optional: to mimic link styling
          >
            {resource_name}
          </span>
        );

      },
      meta: {
        cellProps: { className: 'white-space-nowrap py-4' },
        headerProps: { style: { width: '25%' } }
      }
    },


    {
      header: t('Resource.table.type'),
      accessorKey: 'resource_type',
      meta: {
        headerProps: { style: { width: '10%' }, className: 'ps-3' }
      }
    },

    {
      header: 'Date',
      accessorKey: 'inserted_at',
      meta: {
        cellProps: { className: 'ps-3 text-900 py-4' },
        headerProps: { style: { width: '12%' }, className: 'ps-3' }
      }
    },


  ];

  const table = useAdvanceTable({
    data: resources,
    columns: resourcesListTableColumns,
    pageSize: 10,
    pagination: true,
    sortable: true
  });

  const breadcrumbItems: PageBreadcrumbItem[] = [
    {
      label: t('Dashboard'),
      url: '/dashboard/home'
    },
    {
      label: t('MyResources'),
      active: true
    }
  ];

  const fetchData = async () => {
    try {
      const { data } = await apiClient.get('/v1/resources');
      setResources(data);
      console.log(data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  return (
    <>
      <PageBreadcrumb items={breadcrumbItems} />

      <Row className="mt-3 mb-3 bg-soft email-header">
        <Col className="col-auto">
          <Button
            variant="primary"
            className="email-sidebar-width d-none d-lg-block"
            as={Link}
            to="/apps/email/compose"
          >
            Upload
          </Button>
          <Button
            variant="phoenix-secondary"
            className="px-3 text-700 d-lg-none"

          >
            <FontAwesomeIcon icon={faBars} />
          </Button>
        </Col>
        {page !== 'compose' && (
          <Col className="col-auto d-lg-none">
            <Button variant="primary" className="px-3 px-sm-4">
              <span className="d-none d-sm-inline-block">Compose</span>
              <FontAwesomeIcon icon={faPlus} className="d-sm-none" />
            </Button>
          </Col>
        )}
        <Col className="col-auto flex-1">
          <SearchBox className="w-100" />
        </Col>
      </Row>


      <Row className="g-lg-4 g-xl-6 mb-8">
        <Col lg="auto" className="bg-soft">
          <div
            className="email-sidebar email-sidebar-width d-none d-lg-block"
            id="resourcesSidebarColumn"
          >
            <ResourcesSidebar resources={resources} />
          </div>


          {breakpoints.down('lg') && (
            <PhoenixOffcanvas
              open={openSidebar}
              fixed
              placement="start"
              className="email-sidebar email-sidebar-width bg-soft"
              backdropClassName="top-0"
              onHide={() => setOpenSidebar(false)}
            >
              <EmailSidebar hideSidebar={() => setOpenSidebar(false)} />
            </PhoenixOffcanvas>
          )}

        </Col>



        {/*          */}

        <Col xs={12} lg className="bg-white">
          <div className="px-lg-1">
            <BulkSelectProvider data={resources}>
              <InboxToolbar className="inbox-toolbar" />
              {resources.map((resource, index) => (
                <MyResourceRow index={index} resource={resource} key={resource.resource_id} />
              ))}
            </BulkSelectProvider>
          </div>
        </Col>




      </Row>
    </>



  );

};

export default MyResources;
